export default "__VITE_ASSET__BX5mw0io__"